<template>
    <header class="brand">
        <img :src="evoasisLogo" alt="EVOASIS Logo" class="badge-logo" />
    </header>
    <div class="page-wrap">
        
        <Loading
            v-model:active="loading"
            :can-cancel="false"
            :widh="100"
            :height="100"
            :is-full-page="true"
            :opacity="0.7"
            color="#0dcaf0"
            background-color="#000"
        ></Loading>
        <div class="page">
            <div class="page-title">發票服務申請</div>
            <p class="page-desc">選擇服務類型，變更發票設定｜申請完成後將由系統處理並寄發確認信。</p>

            <!-- 目前發票資訊 -->
            <div v-if="!submitted && !failed_msg" class="current-invoice">
                <div class="ci-header">
                    <span class="ci-badge">目前發票資料</span>
                    <span class="ci-title">根據您的帳戶顯示</span>
                </div>
                <div class="ci-grid" id="ci-row-triple">
                    <div class="ci-item"><div class="ci-label">發票類型</div><div class="ci-val">{{ current_ecpay_invoice_data.category == 'B2B' ? '三聯式發票' : '二聯式發票' }}</div></div>
                    <div v-if="current_ecpay_invoice_data.category == 'B2B'" class="ci-item"><div class="ci-label">統一編號</div><div class="ci-val">{{ current_ecpay_invoice_data.identifier }}</div></div>
                    <div v-if="current_ecpay_invoice_data.category == 'B2B'" class="ci-item"><div class="ci-label">公司抬頭</div><div class="ci-val">{{ current_ecpay_invoice_data.name }}</div></div>
                    <div class="ci-item"><div class="ci-label">最近發票號碼</div><div class="ci-val">{{ current_ecpay_invoice_data.number }}</div></div>
                    <div class="ci-item"><div class="ci-label">收件信箱</div><div class="ci-val">{{ current_ecpay_invoice_data.email }}</div></div>
                </div>
            </div>

            <div v-if="failed_msg || current_ecpay_invoice_data.category" class="card">
                <div v-if="!submitted && !failed_msg" id="form-area">
                    <div class="type-tabs" id="type-tabs">
                        <button v-if="current_ecpay_invoice_data.category == 'B2C'" type="button" class="tab active">
                            <div class="tab-icon"></div>
                            <div class="tab-label">二聯改三聯<br>申請統編</div>
                        </button>
                        <button v-if="current_ecpay_invoice_data.category == 'B2B'" type="button" class="tab" :class="{'active': serviceType==='3update'}" @click="selectService('3update', 'B2B')">
                            <div class="tab-icon"></div>
                            <div class="tab-label">更新統編／抬頭</div>
                        </button>
                        <button v-if="current_ecpay_invoice_data.category == 'B2B'" type="button" class="tab" :class="{'active': serviceType==='3to2'}" @click="selectService('3to2', 'B2C')">
                            <div class="tab-icon"></div>
                            <div class="tab-label">三聯改二聯<br>取消統編</div>
                        </button>
                    </div>

                    <hr />
                    <div v-if="current_ecpay_invoice_data.category != 'B2C' && !serviceType" id="empty-prompt">&#x2191; 請選擇服務類型</div>
                    <!-- Panel 二聯改三聯 -->
                    <div class="panel" :class="{'visible': current_ecpay_invoice_data.category == 'B2C'}" id="panel-2to3">
                        <div class="note">📌 目前為個人二聯式發票，填寫統編與抬頭後將轉為三聯式發票，用於公司報帳。</div>
                        <div class="field-row">
                        <div>
                            <label>統一編號 <span class="req">*</span></label>
                            <input type="text" id="tax-2to3" v-model="form.identifier" maxlength="8" placeholder="請輸入8位數字" autocomplete="off" @blur="touch('identifier')" />
                            <div class="err-msg" :class="{'show': touched.identifier && errors.identifier}">{{ errors.identifier }}</div>
                        </div>
                        <div>
                            <label>公司抬頭 <span class="req">*</span></label>
                            <input type="text" id="company-2to3" v-model="form.name" placeholder="公司完整名稱" autocomplete="off" />
                            <div class="err-msg" :class="{'show': touched.identifier && errors.name}">請填寫公司抬頭</div>
                        </div>
                        </div>
                        <div class="field">
                            <label>收件信箱 <span class="req">*</span> <span class="hint">(將寄送發票通知至此信箱)</span></label>
                            <input type="email" v-model="current_ecpay_invoice_data.email" readonly />
                        </div>
                    </div>

                    <!-- Panel 更新統編/抬頭 -->
                    <div class="panel" :class="{'visible': serviceType==='3update'}" id="panel-3update">
                        <div class="note">🏢 修改統一編號或公司抬頭</div>
                        <div class="field-row">
                        <div>
                            <label>新統一編號 <span class="req">*</span></label>
                            <input type="text" id="tax-3update" v-model="form.identifier" maxlength="8" placeholder="8位數字" autocomplete="off" @blur="touch('identifier')" />
                            <div class="err-msg" :class="{'show': touched.identifier && errors.identifier}">{{ errors.identifier }}</div>
                        </div>
                        <div>
                            <label>新公司抬頭 <span class="req">*</span></label>
                            <input type="text" id="company-3update" v-model="form.name" placeholder="公司全銜" autocomplete="off" />
                            <div class="err-msg" :class="{'show': touched.identifier && errors.name}">{{ errors.name }}</div>
                        </div>
                        </div>
                        <div class="field">
                            <label>收件信箱 <span class="req">*</span> <span class="hint">(將寄送發票通知至此信箱)</span></label>
                            <input type="email" v-model="current_ecpay_invoice_data.email" readonly />
                        </div>
                    </div>

                    <!-- Panel 三聯改二聯 -->
                    <div class="panel" :class="{'visible': serviceType==='3to2'}" id="panel-3to2">
                        <div class="note">🔁 取消統編後將改為二聯式個人發票</div>
                        <div class="field">
                            <label>收件信箱 <span class="req">*</span> <span class="hint">(將寄送發票通知至此信箱)</span></label>
                            <input type="email" v-model="current_ecpay_invoice_data.email" readonly />
                        </div>
                    </div>
                    <button class="submit-btn" id="submit-btn" :disabled="!isValid" @click="onPreview">預覽變更並確認送出</button>
                </div>

                <div v-if="submitted && !failed_msg" id="result-panel">
                    <div class="success circle">✓</div>
                    <div class="title">申請已送出</div>
                    <p class="desc">您的發票變更申請已提交，我們將於 <strong>1–3 個工作天</strong>內以電子郵件通知結果。<br>感謝您使用 EVOASIS 服務。</p>
                </div>

                <div v-if="failed_msg" id="result-panel">
                    <div class="failed circle">✖︎</div>
                    <div class="title">作業失敗</div>
                    <p class="desc">{{ failed_msg }}</p>
                </div>
            </div>
            <footer id="footer-contact">
                如有疑問請聯繫 <a href="mailto:help@evoasis.com.tw" style="color:#00c67a;text-decoration:none;font-weight:500;">help@evoasis.com.tw</a>
            </footer>
        </div>
        <div :class="{'show': preview}" class="overlay" id="confirm-overlay">
            <div class="confirm-card">
                <div class="confirm-title">📋 確認申請內容</div>
                <p class="confirm-sub">請比對變更前後資訊，確認無誤再送出。</p>
                <div class="compare-grid">
                    <div class="compare-col" id="col-old">
                        <div class="compare-col-title">變更前</div>
                        <div class="compare-row"><div class="compare-label">發票類型</div><div class="compare-val">{{ current_ecpay_invoice_data.category == 'B2B' ? '三聯式發票' : '二聯式發票' }}</div></div>
                        <div class="compare-row"><div class="compare-label">統一編號</div><div class="compare-val">{{ current_ecpay_invoice_data.category == 'B2B' ? current_ecpay_invoice_data.identifier : '—' }}</div></div>
                        <div class="compare-row"><div class="compare-label">公司抬頭</div><div class="compare-val">{{ current_ecpay_invoice_data.category == 'B2B' ? current_ecpay_invoice_data.name : '—' }}</div></div>
                        <div class="compare-row"><div class="compare-label">收件信箱</div><div class="compare-val">{{ current_ecpay_invoice_data.email }}</div></div>
                    </div>
                    <div class="compare-arrow">→</div>
                    <div class="compare-col new-col" id="col-new">
                        <div class="compare-col-title">變更後</div>
                        <div class="compare-row"><div class="compare-label">發票類型</div><div class="compare-val" :class="{'changed' : isChanged('category')}">{{ form.category == 'B2B' ? '三聯式發票' : '二聯式發票' }}</div></div>
                        <div class="compare-row"><div class="compare-label">統一編號</div><div class="compare-val" :class="{'changed' : isChanged('identifier')}">{{ form.identifier ?? '—' }}</div></div>
                        <div class="compare-row"><div class="compare-label">公司抬頭</div><div class="compare-val" :class="{'changed' : isChanged('name')}">{{ form.name ?? '—' }}</div></div>
                        <div class="compare-row"><div class="compare-label">收件信箱</div><div class="compare-val">{{ form.email }}</div></div>
                    </div>
                </div>
                <div class="confirm-agree">
                    <label class="agree-label">
                        <input type="checkbox" v-model="agree" id="agree-chk" />
                        <span>我已確實核對上述資料正確，並同意 EVOASIS 進行發票設定變更。</span>
                    </label>
                </div>
                <div class="confirm-btn-row">
                    <button class="btn-back" id="btn-back" @click="onClose">返回修改</button>
                    <button class="btn-confirm" id="btn-confirm" :disabled="!agree" @click="onSubmit">確認，正式送出</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, onBeforeMount, onMounted, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import Loading from 'vue-loading-overlay'
import axios from "axios";
import evoasisLogo from '@/assets/img/evoasis.svg';

axios.defaults.headers.common['Authorization'] = process.env.VUE_APP_EVO_CORE_SERVICE_TOKEN

const route = useRoute()
const loading = ref(true)
const token = ref(route.params.token)

const current_ecpay_invoice_data = ref({
    category: null,  
    email: null,
    identifier: null,
    name: null, 
    number: null
});

const preview = ref(false)
const agree = ref(false)
const submitted = ref(false)
const failed_msg = ref(null)
const serviceType = ref(null)

const defaultForm = () => ({
    category: null,
    email: null,
    identifier: null,
    name: null
});
const form = ref(defaultForm());

watch(
    () => form.value.identifier,
    async (newVal) => {
        if (!newVal) return
        const { data: ubnResponse } = await axios.get(`https://public-api.evoasis.com.tw/myoasis/invoice/company/ubn/${newVal}`)
        form.value.name = ubnResponse.company_name
    },
    { immediate: true }
)

// ── Validation ──
const touched = reactive({});
const touch = key => { touched[key] = true; };

const errors = computed(() => {
    const e = {};
    if (!serviceType.value) e.serviceType = '請選擇服務類型'
    if (form.value.category == 'B2B' && !form.value.identifier || (form.value.identifier && form.value.identifier.length != 8) ) e.identifier = '請輸入正確的8位統一編號';
    if (form.value.category == 'B2B' && !form.value.name ) e.name = '請填寫公司抬頭';
    return e;
});

const isValid = computed(() => Object.keys(errors.value).length === 0);

onMounted(() => document.title = route.meta.title)
onBeforeMount(async () => {
    try {
        await fetchInvoiceData()
    } catch (error) {
        console.log(error);
    }
});

const fetchInvoiceData = async() => {
    const { data: invoiceData } = await axios.get(`https://public-api.evoasis.com.tw/myoasis/invoice/token/${token.value}`)
    loading.value = false
    if(!invoiceData.validity) {
        failed_msg.value = '此連結已失效，請至官網或APP重新申請，謝謝。'
        return
    }
    let { IIS_Category, IIS_Customer_Email, IIS_Customer_Name, IIS_Identifier, IIS_Number } = invoiceData.data.current_ecpay_invoice_data

    current_ecpay_invoice_data.value['category'] = IIS_Category
    current_ecpay_invoice_data.value['email'] = IIS_Customer_Email
    current_ecpay_invoice_data.value['number'] = IIS_Number
    current_ecpay_invoice_data.value['identifier'] = IIS_Identifier
    current_ecpay_invoice_data.value['name'] = IIS_Customer_Name
    form.value.email = IIS_Customer_Email

    if(IIS_Category == 'B2C') {
        serviceType.value = '2to3'
        form.value.category = 'B2B'
    }
}

const selectService = (service, category) => {
    form.value = defaultForm()
    serviceType.value = service
    form.value.email = current_ecpay_invoice_data.value.email
    form.value.category = category
}
const isChanged = (key) => current_ecpay_invoice_data.value[key] != form.value[key]

const onPreview = () => {
    preview.value = true
    document.body.style.overflow = 'hidden'
}
const onClose = () => {
    preview.value = false
    document.body.style.overflow = ''
}
const onSubmit = async() => {
    loading.value = true
    
    const { data: reissueInvoiceResponse } = await axios.post('https://public-api.evoasis.com.tw/myoasis/invoice/reissue', {
        token: token.value,
        data: {
            CustomerIdentifier: form.value.category == 'B2C' ? null : form.value.identifier,
            CustomerName: form.value.category == 'B2C' ? null : form.value.name,
            CustomerEmail: form.value.email
        }
    })
    
    if(reissueInvoiceResponse.code != 'reissue_operation_is_done') failed_msg.value = '請聯繫客服'
    loading.value = false
    preview.value = false
    submitted.value = true
    document.body.style.overflow = ''
}
</script>

<style lang="scss" scoped>
    .page-wrap { font-family: 'Noto Sans TC', sans-serif; background: #f5f5f5; color: #1a1a1a; min-height: 100vh; text-align: initial; }

    header { background: #fff; border-bottom: 1px solid #e8e8e8; padding: 0 40px; height: 64px; display: flex; align-items: center; justify-content: center; box-shadow: 0 1px 2px rgba(0,0,0,0.02); }
    header img { height: 32px; display: block; }

    .page { max-width: 680px; margin: 0 auto; padding: 40px 20px 60px; }
    .page-title { font-size: 24px; font-weight: 700; margin-bottom: 6px; }
    .page-desc { font-size: 14px; color: #6c6c70; margin-bottom: 28px; line-height: 1.5; }

    .current-invoice { background: #fff; border: 1px solid #e8e8e8; border-radius: 12px; padding: 20px 24px; margin-bottom: 16px; }
    .ci-header { display: flex; align-items: center; gap: 8px; margin-bottom: 18px; flex-wrap: wrap; }
    .ci-badge { font-size: 11px; font-weight: 600; color: #fff; background: #00c67a; padding: 4px 12px; border-radius: 30px; letter-spacing: 0.3px; }
    .ci-title { font-size: 13px; color: #8e8e93; }
    .ci-mock-btns { margin-left: auto; display: flex; gap: 8px; flex-shrink: 0; }
    .mock-btn { font-size: 12px; padding: 4px 14px; border-radius: 20px; cursor: pointer; font-family: inherit; transition: all 0.2s ease; background: #fff; border: 1px solid #ddd; color: #555; font-weight: 500; }
    .mock-btn.on  { border-color: #00c67a; background: #e9f9f2; color: #008f53; }
    .mock-btn.off { border-color: #e2e2e2; background: #fefefe; color: #8a8a8e; }

    .ci-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 14px 20px; }
    .ci-item .ci-label { font-size: 11px; color: #a0a0a5; margin-bottom: 4px; letter-spacing: 0.3px; }
    .ci-item .ci-val   { font-size: 14px; font-weight: 550; color: #1c1c1e; word-break: break-word; }

    .card { background: #fff; border-radius: 12px; border: 1px solid #e8e8e8; padding: 32px; }

    .type-tabs { display: flex; gap: 12px; margin-bottom: 28px; flex-wrap: wrap; }
    .tab { flex: 1; min-width: 120px; border: 1.5px solid #e0e0e0; background: #fafafa; border-radius: 8px; padding: 10px 8px; cursor: pointer; text-align: center; transition: all 0.2s; font-family: 'Noto Sans TC', sans-serif; }
    .tab:hover  { border-color: #b8e4d2; background: #f6fef9; }
    .tab.active { border-color: #00c67a; background: #f0fdf8; box-shadow: 0 2px 6px rgba(0,198,122,0.08); }
    .tab-icon  { font-size: 20px; margin-bottom: 4px; }
    .tab-label { font-size: 14px; font-weight: 600; color: #3a3a3e; }
    .tab.active .tab-label { color: #008f53; font-weight: 600; }

    hr { border: none; border-top: 1px solid #eff2f6; margin: 0 0 24px; opacity: 1; }

    .panel { display: none; }
    .panel.visible { display: block; animation: fadeSlide 0.25s ease; }
    @keyframes fadeSlide { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: translateY(0); } }

    #empty-prompt { text-align: center; padding: 24px 0 8px; font-size: 14px; color: #bbb; }

    .note { background: #f6fef9; border-left: 3px solid #00c67a; border-radius: 0 6px 6px 0; padding: 10px 14px; font-size: 14px; color: #555; line-height: 1.5; margin-bottom: 20px; }

    .field { margin-bottom: 22px; }
    .field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; margin-bottom: 22px; }

    label { display: block; font-size: 12px; font-weight: 600; color: #5c5c62; margin-bottom: 6px; letter-spacing: 0.2px; }
    label .req { color: #00c67a; margin-left: 2px; }
    label .hint { font-size: 11px; font-weight: normal; color: #8e8e93; margin-left: 6px; }

    input[type="text"], input[type="email"], input[type="date"] {
        width: 100%; border: 1.5px solid #e2e6ec; border-radius: 10px; padding: 12px 15px;
        font-size: 14px; color: #1c1c1e; font-family: 'Noto Sans TC', sans-serif;
        background: #fff; outline: none; transition: all 0.2s;
    }
    input:focus { border-color: #00c67a; box-shadow: 0 0 0 3px rgba(0,198,122,0.1); }
    input.err   { border-color: #e85d5d; background-color: #fff8f8; }
    input:read-only { background: #f8f9fa; border-color: #e8ecef; color: #6c757d; cursor: default; }

    .err-msg { font-size: 11px; color: #e05252; margin-top: 5px; display: none; font-weight: 500; }
    .err-msg.show { display: block; }

    .submit-btn { width: 100%; margin-top: 6px; padding: 14px; background: #00c67a; color: #fff; border: none; border-radius: 8px; font-size: 16px; font-weight: 700; font-family: 'Noto Sans TC', sans-serif; cursor: pointer; transition: 0.2s; letter-spacing: 0.8px; box-shadow: 0 2px 6px rgba(0,198,122,0.2); }
    .submit-btn:hover    { background: #00a362; transform: translateY(-1px); }
    .submit-btn:disabled { background: #cfe6dc; cursor: not-allowed; box-shadow: none; transform: none; }

    .overlay { display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.45); backdrop-filter: blur(2px); z-index: 300; align-items: center; justify-content: center; padding: 20px; }
    .overlay.show { display: flex; }

    .confirm-card { background: #fff; border-radius: 14px; padding: 32px 28px; width: 100%; max-width: 560px; box-shadow: 0 30px 50px rgba(0,0,0,0.2); max-height: 80vh; overflow-y: auto; -webkit-overflow-scrolling: touch; }

    .confirm-title { font-size: 20px; font-weight: 700; margin-bottom: 8px; }
    .confirm-sub   { font-size: 13px; color: #8a8a8e; margin-bottom: 28px; border-left: 2px solid #e2e6ec; padding-left: 12px; }

    .compare-grid { display: grid; grid-template-columns: 1fr 32px 1fr; align-items: start; margin-bottom: 24px; }
    .compare-col { border-radius: 10px; padding: 16px; background: #fafafa; border: 1px solid #e8e8e8; }
    .compare-col.new-col { background: #f6fef9; border-color: #c6eedb; }
    .compare-col-title { font-size: 12px; font-weight: 700; color: #8e8e93; letter-spacing: 0.5px; text-transform: uppercase; margin-bottom: 16px; }
    .compare-col.new-col .compare-col-title { color: #008f53; }
    .compare-row { margin-bottom: 12px; display: flex; flex-direction: column; gap: 2px; }
    .compare-label { font-size: 11px; color: #9c9ca2; }
    .compare-val   { font-size: 14px; font-weight: 600; color: #1c1c1e; word-break: break-word; }
    .compare-val.changed { color: #00a362; }
    .compare-arrow { display: flex; align-items: center; justify-content: center; padding-top: 36px; font-size: 18px; color: #cdd2da; font-weight: 300; }

    .confirm-agree { margin-bottom: 16px; }
    .agree-label { display: flex; align-items: flex-start; gap: 12px; cursor: pointer; }
    .agree-label input[type="checkbox"] { width: 18px; height: 18px; margin-top: 1px; flex-shrink: 0; accent-color: #00c67a; cursor: pointer; }
    .agree-label span { font-size: 13px; color: #3c3c40; line-height: 1.45; font-weight: 500; }

    .confirm-btn-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
    .btn-back    { padding: 12px; background: #fff; border: 1.5px solid #e2e6ec; border-radius: 8px; font-size: 14px; font-weight: 600; color: #5c5c62; font-family: 'Noto Sans TC', sans-serif; cursor: pointer; transition: 0.15s; }
    .btn-back:hover { border-color: #bdbdbd; background: #f9f9fc; }
    .btn-confirm {
        padding: 12px; border: none; border-radius: 8px; font-size: 14px; font-weight: 700;
        font-family: 'Noto Sans TC', sans-serif; cursor: pointer; transition: 0.2s;
        background: #00c67a; color: #fff;
    }
    .btn-confirm:not(:disabled):hover { background: #008f53; }
    .btn-confirm:disabled { background: #e8e8e8; color: #bbb; cursor: not-allowed; opacity: 1; }

    #result-panel { display: block; text-align: center; padding: 28px 12px 24px; }
    .circle { width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; margin: 0 auto 16px; }
    .circle.success { background: #f0fdf8; border: 2px solid #00c67a; }
    .circle.failed { background: #fdf0f0; border: 2px solid #c60000; }
    #result-panel .title { font-size: 18px; font-weight: 700; margin-bottom: 12px; }
    #result-panel .desc  { font-size: 14px; color: #888; line-height: 1.7; }

    footer { text-align: center; font-size: 12px; color: #aaa; padding: 20px 0 10px; }

    @media (max-width: 560px) {
        header { padding: 0 20px; }
        .card { padding: 24px 18px; }
        .type-tabs { gap: 8px; }
        .tab { flex: 1 1 100px; padding: 8px 5px; border-radius: 10px; }
        .tab-label { font-size: 11px; }
        .field-row { grid-template-columns: 1fr; gap: 16px; }
        .ci-grid { grid-template-columns: 1fr 1fr; gap: 10px; }
        .compare-grid { grid-template-columns: 1fr; gap: 16px; }
        .compare-arrow { display: none; }
        .confirm-card { padding: 24px 18px; }
        .submit-btn { border-radius: 10px; }
        .btn-back, .btn-confirm { border-radius: 10px; }
    }
</style>